// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2234":"css/admin-app.6802","7911":"css/app.6802"}[chunkId] + ".css";
};